export default __webpack_public_path__ + "static/media/cow-no-connection.733d02c1.png";